<template>
    <div v-if="getNavigationItems">
        <template v-for="item in getNavigationItems.filter(x => !x.menu)">
            <v-btn class="toolbar-btn text-transform-unset letter-spacing-custom textColor textBold" height="52" :key="item.to" text :to="item.to" tile dark>
                {{ $t(item.title) }}
            </v-btn>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppNavigation',
    data: () => ({
        drawer: true
    }),
    computed: {
        ...mapGetters('auth', ['loggedIn']),
        ...mapGetters('base', ['getNavigationItems'])
    },
    methods: {
        openLink(item, child) {
            const name = child.to || item.to;
            const params = item.param ? { [item.param]: child[item.param] } : {};
            this.$router.push({ name, params });
        }
    }
};
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
.letter-spacing-custom {
    letter-spacing: 0.0392857143em;
}
.toolbar-btn {
    font-weight: 500 !important;
}
</style>
